import { LocalizedNode } from "./types";
import { isLocalizedParentNode } from "./utils";

export type FormTreeAction =
	| { type: "init"; payload: { nodes: LocalizedNode[] } }
	| { type: "toggle"; payload: { path: string[] } }
	| { type: "collapse-all" }
	| { type: "expand-all" };

export function formTreeReducer(
	nodes: LocalizedNode[],
	action: FormTreeAction
): LocalizedNode[] {
	if (action.type === "init") {
		return action.payload.nodes;
	}
	if (action.type === "toggle") {
		return toggleNodeByPath(nodes, action.payload.path);
	}
	if (action.type === "collapse-all") {
		return collapseAll(nodes);
	}
	if (action.type === "expand-all") {
		return expandAll(nodes);
	}
	return nodes;
}

function toggleNodeByPath(
	nodes: LocalizedNode[],
	path: string[]
): LocalizedNode[] {
	if (path.length === 0) {
		throw new Error();
	}
	const [id, ...nextPath] = path;
	if (nextPath.length === 0) {
		return nodes.map(node =>
			isLocalizedParentNode(node) && node.id === id
				? { ...node, isOpen: !node.isOpen }
				: node
		);
	}
	return nodes.map(node =>
		isLocalizedParentNode(node) && node.id === id
			? { ...node, children: toggleNodeByPath(node.children, nextPath) }
			: node
	);
}

function collapseAll(nodes: LocalizedNode[]): LocalizedNode[] {
	return nodes.map(node =>
		isLocalizedParentNode(node)
			? { ...node, isOpen: false, children: collapseAll(node.children) }
			: node
	);
}

function expandAll(nodes: LocalizedNode[]): LocalizedNode[] {
	return nodes.map(node =>
		isLocalizedParentNode(node)
			? { ...node, isOpen: true, children: expandAll(node.children) }
			: node
	);
}
